import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import * as StackTrace from 'stacktrace-js';

import { UnauthorizedError } from './../shared/errors/unauthorized-error';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from './logger.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppExceptionHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error): any {
    if (error instanceof UnauthorizedError) {
      return;
    }

    const logger = this.injector.get(LoggerService);
    // tslint:disable-next-line: deprecation
    const location = this.injector.get(LocationStrategy);
    const toastr = this.injector.get(ToastrService);
    const zone = this.injector.get(NgZone);
    const url = location instanceof PathLocationStrategy ? location.path() : '';
    const displayMessage = error.message ? error.message : error.toString();
    const logMessage = `${url} - ${displayMessage}`;

    StackTrace.fromError(error)
      .then(stackframes => {
        const stackString = stackframes
          .splice(0, 20)
          .map(sf => {
            return sf.toString();
          })
          .join(' ');

        logger.logError({ message: logMessage, stackTrace: stackString });
        const isTemplateError = stackString.includes('updateRenderer');
        if (!isTemplateError) {
          zone.run(() => toastr.error(displayMessage.slice(0, 100), 'Error'));
        } else if (environment.redirectOnError) {
          window.location.href = '/error.html';
        }
        super.handleError(error);
      })
      .catch(err => {
        logger.logError({ message: logMessage, stackTrace: '' });
        zone.run(() => toastr.error(displayMessage));
        super.handleError(error);
      });
  }
}
